<template>
  <div>
    <v-slide-group
      v-if="$vuetify.breakpoint.width > 800"
      center-active
      max="1"
      show-arrows
      class="slider-items"
    >
      <v-slide-item v-for="(item, index) in items" :key="index">
        <v-card class="ma-5 publish-item">
          <div
            class="publish-item d-flex pointer"
            @click="goToPublisherId(item)"
          >
            <div class="product-image">
              <img :src="item.logoId ? item.logoUrl : '/no-image.png'" alt="" />
            </div>
          </div>
        </v-card>
      </v-slide-item>
    </v-slide-group>

    <v-carousel v-else style="height: 300px" hide-delimiters>
      <div v-if="$vuetify.breakpoint.width < 600">
        <v-carousel-item
          v-if="$vuetify.breakpoint.width < 600"
          v-for="(item, index) in items"
          :key="index"
        >
          <v-card class="ma-5 publish-item">
            <div
              class="publish-item d-flex pointer"
              @click="goToPublisherId(item)"
            >
              <div class="product-image">
                <img
                  :src="item.logoId ? item.logoUrl : '/no-image.png'"
                  alt=""
                />
              </div>
            </div>
          </v-card>
        </v-carousel-item>
      </div>
      <div v-else>
        <v-carousel-item v-for="(item, index) in computedItems" :key="index">
          <v-card class="ma-5 publish-item">
            <div
              class="publish-item d-flex pointer"
              @click="goToPublisherId(item.items[0])"
            >
              <div class="product-image">
                <img
                  :src="
                    item.items[0].logoId
                      ? item.items[0].logoUrl
                      : '/no-image.png'
                  "
                  alt=""
                />
              </div>
            </div>
          </v-card>
          <v-card class="ma-5 publish-item" v-if="item.items[1]">
            <div
              class="publish-item d-flex pointer"
              @click="goToPublisherId(item.items[1])"
            >
              <div class="product-image">
                <img
                  :src="
                    item.items[1].logoId
                      ? item.items[1].logoUrl
                      : '/no-image.png'
                  "
                  alt=""
                />
              </div>
            </div>
          </v-card>
        </v-carousel-item>
      </div>
    </v-carousel>
  </div>
</template>

<script>
import vueCarousel from "vue-carousel";

export default {
  name: "publisherSlider",
  components: {
    vueCarousel,
  },
  props: {
    items: {},
  },
  data() {
    return {
      computedItems: [],
    };
  },
  methods: {
    goToPublisherId(item) {
      let link = `/publisher/${item.name.replaceAll(" ", "-")}-${item.id}`;
      this.$router.push(link, "_blank");
    },
    sliceItems() {
      for (let i = 0; i < this.items.length / 2; i++) {
        if (i == 0) {
          this.computedItems.push({
            items: [this.items[i], this.items[i + 1]],
          });
        } else {
          this.computedItems.push({
            items: [this.items[i * 2], this.items[i * 2 + 1]],
          });
        }
      }
    },
  },
  mounted() {
    this.sliceItems();
  },
};
</script>
<style lang="scss" scoped>
.slider-items {
  & .v-slide-group__wrapper {
    .v-slide-group__content {
      border-bottom: none !important;
    }
  }
  & [class~="v-slide-group__next"] {
    min-width: 25px !important;
  }
  & [class~="v-slide-group__prev"] {
    min-width: 25px !important;
  }
}
.main-page {
  .products {
    // &.special-products {
    //   overflow-x: auto;
    //   overflow-y: hidden;
    //   scroll-behavior: smooth;
    //   .product-item {
    //     max-width: none;
    //   }
    //   &::-webkit-scrollbar {
    //     display: none;
    //   }
    // }

    .publish-item {
      width: 100%;
      height: 250px;
      background-color: #fff;
      border-radius: 12px;
      overflow: hidden;
      @media (max-width: 1024px) {
        width: 250px;
        justify-content: center;
      }
      @media (max-width: 375px) {
        width: 200px;
        justify-content: center;
      }
      .product-image {
        height: 250px;
        @media (max-width: 375px) {
          width: 100%;
          height: 100%;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    // .publish-item {
    //   max-width: 250px;
    //   height: 250px;
    //   @media (max-width: 375px) {
    //     max-width: 200px;
    //     justify-content: center;
    //   }
    //   .product-image {
    //     width: 230px;
    //     height: 230px;
    //     @media (max-width: 375px) {
    //       width: 190px;
    //     }
    //     img {
    //       width: 100%;
    //       height: 100%;
    //       object-fit: contain;
    //     }
    //   }
    // }
  }
}

.slider {
  position: relative;
  @media only screen and (min-width: 1279px) {
    margin: 0 46px;
  }
  @media only screen and (max-width: 1279px) {
    margin: 0 10px;
  }
  &-button {
    position: absolute;
    transform: translateY(-30px);
    .v-btn {
      height: 50px !important;
      border-radius: 50px !important;
      background-color: #c6b9e4;
      i {
        color: #a076f9;
      }
    }
  }
  .slider-right-button {
    top: 50%;
    right: -60px;
  }
  .slider-left-button {
    top: 50%;
    left: -60px;
  }
}
.banner {
  overflow-x: hidden !important;
  width: 100% !important;
  height: auto !important;
  background-size: cover !important;
  position: center !important;
  @media screen and (max-width: 600px) {
    height: 150px !important;
    background-size: cover !important;
    position: center !important;
    width: 100% !important;
  }
}
</style>
